import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { ReactivateRefundRequestInput } from '../domain/dtos/reactivate-refund-request-input'
import { Refund } from '../domain/dtos/refund'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ReactivateRefundRequest {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: ReactivateRefundRequestInput): Promise<Refund> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_WEB_URL}/refunds/${input.refundId}/reactivate`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }
}
